import { render, staticRenderFns } from "./valentine.vue?vue&type=template&id=5056a1b8"
import script from "./valentine.vue?vue&type=script&lang=js"
export * from "./valentine.vue?vue&type=script&lang=js"
import style0 from "./valentine.vue?vue&type=style&index=0&id=5056a1b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports